import { LocationsRequest } from '../common/locations.model';

export interface OrganTransplantLocationsRequest extends LocationsRequest {
  includeOpos?: boolean;
  includeOtcs?: boolean;
  organList?: string[];
}

export const OrganTransplantTypes = [
  {
    value: 'All Transplant Programs', // includeOpos = true all others false
    id: 'all',
    name: 'All Transplant Programs'
  },
  {
    value: 'Heart',
    id: 'heart',
    name: 'Heart'
  },
  {
    value: 'Intestine',
    id: 'intestine',
    name: 'Intestine'
  },
  {
    value: 'Kidney',
    id: 'kidney',
    name: 'Kidney'
  },
  {
    value: 'Liver',
    id: 'liver',
    name: 'Liver'
  },
  {
    value: 'Lung',
    id: 'lung',
    name: 'Lung'
  },
  {
    value: 'Pancreas',
    id: 'pancreas',
    name: 'Pancreas'
  },
  {
    value: 'Pancreas Islet',
    id: 'pancreasIslet',
    name: 'Pancreas Islet'
  },
  {
    value: 'Vascularized Composite Allograft (VCA)',
    id: 'vascularized',
    name: 'Vascularized Composite Allograft (VCA)'
  }
];
